module.exports = __webpack_public_path__ + "img/icon_capability02.d5803ad8.png";